import React from 'react';

// Standardized brand mark: "Rejumist" followed by a ™ rendered at 1/4 the size of
// the parent font, raised as a superscript right after the last "t".
// Accepts an optional style prop applied to the outer <span>.
export const BrandName = ({ style = {}, className }) => (
  <span style={style} className={className}>
    Rejumist
    <span
      style={{
        fontSize: '0.45em',
        position: 'relative',
        top: '-0.55em',
        marginLeft: '0.05em',
        lineHeight: 0,
        display: 'inline-block',
      }}
    >
      {'\u2122'}
    </span>
  </span>
);

export default BrandName;
